import { render, staticRenderFns } from "./productshop.vue?vue&type=template&id=6707ff46&scoped=true&"
import script from "./productshop.vue?vue&type=script&lang=js&"
export * from "./productshop.vue?vue&type=script&lang=js&"
import style0 from "./productshop.vue?vue&type=style&index=0&id=6707ff46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707ff46",
  null
  
)

export default component.exports